<template>
    <!-- Vertical Card Layout -->
    <Link v-if="type === 'vertical'" :href="'/artist/' + artist.id" class="w-full block">
        <div
            class="text-center space-y-3 p-4 rounded-lg bg-nomad-800 hover:bg-nomad-700 hover:shadow-lg transition-all duration-300">
            <!-- Artist Image -->
            <img :src="artist.image" :alt="artist.name" class="rounded-lg h-32 w-32 object-cover mx-auto" />
            <!-- Artist Name -->
            <h2 class="text-lg font-semibold text-white truncate">
                {{ artist.name }}
            </h2>
            <!-- Song Count -->
            <p class="text-md font-light text-nomad-300">
                {{ artist.songs_count }} {{ artist.songs_count === 1 ? 'song' : 'songs' }}
            </p>
        </div>
    </Link>

    <!-- Horizontal Card Layout -->
    <Link v-else :href="'/artist/' + artist.id" class="w-full block">
        <div
            class="flex items-center gap-4 p-4 rounded-lg bg-nomad-800 hover:bg-nomad-700 hover:shadow-lg transition-all duration-300">
            <!-- Artist Image -->
            <img :src="artist.image" :alt="artist.name" class="rounded-lg h-20 w-20 object-cover flex-shrink-0" />
            <!-- Artist Info -->
            <div class="flex-1 min-w-0">
                <h2 class="text-lg font-semibold text-white truncate">
                    {{ artist.name }}
                </h2>
                <p class="text-md font-light text-nomad-300">
                    {{ artist.songs_count }} {{ artist.songs_count === 1 ? 'song' : 'songs' }}
                </p>
            </div>
        </div>
    </Link>
</template>
<script setup>
defineProps({ artist: Object, type: { type: String, default: "vertical" } });
</script>
<script>
import { Link } from "@inertiajs/vue3";
export default {
    components: {
        Link,
    },
};
</script>
